import { PALETTE } from '../../constants/palette';
import { hexToRgba } from '../../utils';

export const colors = {
  neutral: {
    base: PALETTE.white,
    100: PALETTE.neutrals.dark.grey120,
    150: PALETTE.neutrals.dark.grey150,
    200: PALETTE.neutrals.dark.grey60,
    250: PALETTE.neutrals.dark.grey180,
    280: PALETTE.neutrals.dark.grey100,
    300: PALETTE.smokyBlack,
    350: PALETTE.neutrals.dark.grey180,
    400: PALETTE.neutrals.dark.grey180,
    500: PALETTE.neutrals.dark.grey300,
    550: PALETTE.neutrals.dark.grey500,
    600: PALETTE.neutrals.dark.grey500,
    700: PALETTE.neutrals.dark.grey600,
    750: PALETTE.neutrals.dark.grey700,
    800: PALETTE.neutrals.dark.grey900,
  },
  primary: {
    100: PALETTE.accent.tomato,
  },
  secondary: {
    100: PALETTE.accent.blueJeans,
  },
  system: {
    100: PALETTE.accent.fireOpal,
    200: PALETTE.accent.sunsetOrange,
    300: PALETTE.accent.ripeMango,
    400: PALETTE.accent.forestGreen,
    500: PALETTE.white,
  },
  text: {
    base: PALETTE.white,
    100: hexToRgba(PALETTE.white, 0.9),
    200: hexToRgba(PALETTE.white, 0.7),
    300: hexToRgba(PALETTE.white, 0.6),
    400: hexToRgba(PALETTE.white, 0.5),
    500: hexToRgba(PALETTE.white, 0.3),
  },
  link: {
    100: {
      base: PALETTE.accent.blueJeans,
      hover: PALETTE.white,
    },
    200: {
      base: PALETTE.accent.tomato,
    },
  },
  custom: {
    loggedOutBg: PALETTE.custom.loggedOutBg,
  },
};
